module.exports = __webpack_public_path__ + "static/media/Info.c61ce75c.svg";